import { Component, Input } from '@angular/core';

@Component({
  selector: 'empty-state',
  templateUrl: './empty-state.component.html',
  styleUrls: ['./empty-state.component.scss'],
})
export class EmptyStateComponent {
  @Input() emptyText: string;
  @Input() data: Array<any> | any;
  @Input() isLoading: boolean = false;
  @Input() isError: boolean = false;
}
